import { SettingGroup } from "../types"
import { SettingStore } from "~models/setting-store"
import { WalletStore } from "~models/wallet-store"
import { getMessageDestructOptionLabel } from "../self-destruct-time-settings/msg-destruct-time-options"

type ChatSchemaDeps = {
  settingStore: SettingStore,
  walletStore: WalletStore
}
export const chatSchema = ({
  settingStore,
  walletStore
}: ChatSchemaDeps): SettingGroup[] => [
    // {
    //     title: "发送设置",
    //     contents: [
    //         {
    //             id: "chat.enterSend",
    //             type: "switch",
    //             title: "回车键发送",
    //             content: "按回车键直接发送消息",
    //             suffix: {
    //                 type: "switch",
    //                 value: settingStore.enterToSend,
    //                 onChange: settingStore.setEnterToSend,
    //             },
    //             icon: "hcjfs",
    //             iconColor: "#07c160",
    //             iconSize: 16,
    //             bg: "rgba(7, 193, 96, 0.1)"
    //         },
    //         {
    //             id: "chat.groupAssistant",
    //             type: "navigate",
    //             title: "群发助手",
    //             content: "批量发送消息给多个联系人",
    //             suffix: {
    //                 type: "text",
    //                 value: "未设置",
    //             },
    //             icon: "qlltz",
    //             iconColor: "#07c160",
    //             iconSize: 16,
    //             bg: "rgba(7, 193, 96, 0.1)"
    //         },
    //         {
    //             id: "chat.inputStatus",
    //             type: "switch",
    //             title: "输入状态显示",
    //             content: "让对方看到您正在输入",
    //             suffix: {
    //                 type: "switch",
    //                 value: settingStore.typingStatus,
    //                 onChange: settingStore.setTypingStatus,
    //             },
    //             icon: "srztxs",
    //             iconColor: "#07c160",
    //             iconSize: 16,
    //             bg: "rgba(7, 193, 96, 0.1)"
    //         },
    //         {
    //             id: "chat.readReceipt",
    //             type: "switch",
    //             title: "已读回执",
    //             content: "显示消息已读状态",
    //             suffix: {
    //                 type: "switch",
    //                 value: settingStore.readReceipt,
    //                 onChange: settingStore.setReadReceipt,
    //             },
    //             icon: "ydhz",
    //             iconColor: "#07c160",
    //             iconSize: 16,
    //             bg: "rgba(7, 193, 96, 0.1)"
    //         },
    //     ]
    // },
    // {
    //     title: "表情和贴纸",
    //     contents: [
    //         {
    //             id: "chat.emojis",
    //             type: "navigate",
    //             title: "表情包",
    //             content: "管理和下载表情包",
    //             suffix: {
    //                 type: "text",
    //                 value: "默认",
    //             },
    //             icon: "Union-1",
    //             iconColor: "#4e98f3",
    //             iconSize: 16,
    //             bg: "rgba(78, 152, 243, 0.1)"
    //         },
    //         {
    //             id: "chat.emojisEnable",
    //             type: "switch",
    //             title: "启用表情符号",
    //             content: "在聊天中使用表情符号",
    //             suffix: {
    //                 type: "switch",
    //                 value: settingStore.enableEmoji,
    //                 onChange: settingStore.setEnableEmoji,
    //             },
    //             icon: "bqfh",
    //             iconColor: "#4e98f3",
    //             iconSize: 16,
    //             bg: "rgba(78, 152, 243, 0.1)",
    //         },
    //         {
    //             id: "chat.stickersEnable",
    //             type: "switch",
    //             title: "启用贴纸",
    //             content: "在聊天中使用贴纸",
    //             suffix: {
    //                 type: "switch",
    //                 value: settingStore.enableSticker,
    //                 onChange: settingStore.setEnableSticker,
    //             },
    //             icon: "zhaopian",
    //             iconColor: "#4e98f3",
    //             iconSize: 16,
    //             bg: "rgba(78, 152, 243, 0.1)",
    //         }
    //     ]
    // },
    {
        title: "消息管理",
        contents: [
            {
                id: "chat.destructionTimer",
                type: "switch",
                title: "消息定时自毁",
                content: "消息在指定时间后自动删除",
                suffix: {
                    type: "switch",
                    value: walletStore.msg_destruct_enabled,
                    onChange: settingStore.setMessageSelfDestruct,
                },
                icon: "delete",
                iconColor: "#c332d0",
                iconSize: 16,
                bg: "rgba(195, 50, 208, 0.1)",
            },
            {
                id: "chat.settingTimer",
                type: "navigate",
                title: "自毁时间设置",
                content: "设置消息自毁的时间",
                suffix: {
                    type: "text",
                    value: getMessageDestructOptionLabel(walletStore.msg_destruct_option),
                },
                icon: "delete",
                iconColor: "#c332d0",
                iconSize: 16,
                bg: "rgba(195, 50, 208, 0.1)",
            },
            
        ]
    }
]
